import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function QuizUpload() {
    const [file, setFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [successData, setSuccessData] = useState(null);

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setError('');
            setSuccessData(null);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        setSuccessData(null);

        if (!file) {
            setError('Wybierz plik CSV.');
            return;
        }

        if (file.type !== 'text/csv' && !file.name.toLowerCase().endsWith('.csv')) {
            setError('Plik musi mieć rozszerzenie .csv.');
            return;
        }

        if (file.size > 1_000_000) {
            setError('Plik przekracza maksymalny rozmiar 1 MB.');
            return;
        }

        setIsLoading(true);

        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await fetch('/api/quiz/upload', {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                let errorMessage = `Błąd HTTP! status: ${response.status}`;
                try {
                    const errorData = await response.json();
                    errorMessage = errorData.message || errorMessage;
                } catch (e) {
                }
                throw new Error(errorMessage);
            }

            const data = await response.json();
            setSuccessData(data);
        } catch (e) {
            console.error('Quiz upload error:', e);
            setError(e.message || 'Nie udało się przesłać quizu.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <main className="container">
            <div className="quiz-upload-container">
                <h2>Dodaj quiz z pliku CSV</h2>
                <form onSubmit={handleSubmit} className="quiz-upload-form">
                    <div className="input-group">
                        <label htmlFor="csv-file">Plik CSV:</label>
                        <input
                            id="csv-file"
                            type="file"
                            accept=".csv,text/csv"
                            onChange={handleFileChange}
                            disabled={isLoading}
                        />
                    </div>
                    {error && <p style={{ color: 'red' }}>Błąd: {error}</p>}
                    {successData && (
                        <div className="quiz-upload-success">
                            <p>Quiz został pomyślnie przesłany.</p>
                            <p>Nazwa: {successData.name}</p>
                            <p>Pytania: {successData.numQuestions}</p>
                            <p>Maksymalna liczba punktów: {successData.maxScore}</p>
                            <Link to={`/quiz/${successData.id}`}>Otwórz quiz</Link>
                        </div>
                    )}
                    <button
                        type="submit"
                        className="btn"
                        disabled={isLoading || !file}
                        style={{ marginTop: '1.5rem' }}
                    >
                        {isLoading ? 'Przesyłanie...' : 'Prześlij'}
                    </button>
                </form>
            </div>
        </main>
    );
}

export default QuizUpload;
